import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
// import { media } from "src/styles/breakpoints"
import { slugify } from "src/utils/helpers"

const Tags = ({ items, className }) => {
  return (
    <Wrapper className={className}>
      {items.map((item, index) => (
        <Tag key={index} to={`/resources/keywords/${slugify(item)}`}>
          <TagInner>{item}</TagInner>
        </Tag>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px -10px;
`

export const Tag = styled(Link)`
  display: inline-block;
  height: 26px;
  margin: 0 5px 10px;
  padding: 0 10px;
  position: relative;
  background: linear-gradient(#dbf2f1, #d8edf2);
  border-radius: 2px;
  font-size: 13px;
  line-height: 26px;
  color: #08a195;

  &::before {
    content: "";
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
    background: linear-gradient(#cfefef, #cae8f0);
    transition: 0.1s;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }
`

export const TagInner = styled.span`
  position: relative;
`

export default Tags
